/// <amd-module name="Search/WorkItem/Flux/Stores/ItemContentStore" />
import * as VSSStore from "VSS/Reflux/Store";
import { IItemChangedPayload } from "Search/Shared/Base/ActionsHub";
import { ISeedData } from "Search/Shared/Base/Types";
import { WorkItemResult } from "Search/LegacyWebApi/Contracts/WorkItem";

export interface IItemContentStoreState {
    selectedItem: WorkItemResult;
}

export class ItemContentStore extends VSSStore.Store {
    private _state = {} as IItemContentStoreState;

    constructor(changedEventName: string, data?: ISeedData<WorkItemResult>) {
        super(changedEventName);
        if (data && data.activeItem) {
            this._state.selectedItem = data.activeItem;
        }
    }

    public get state(): IItemContentStoreState {
        return this._state;
    }

    public changeActiveItem = (payload: IItemChangedPayload<WorkItemResult>): void => {
        this._state.selectedItem = payload.item;
        this.emitChanged();
    }
}
